import { render, staticRenderFns } from "./Breaking.vue?vue&type=template&id=3cd931e9&"
import script from "./Breaking.vue?vue&type=script&lang=js&"
export * from "./Breaking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports